import React from 'react'
import { connect } from 'react-redux'
import { Route, Switch, Redirect } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import Loadable from 'react-loadable'
import jwt from 'jsonwebtoken'

import Loader from 'components/LayoutComponents/Loader'
import IndexLayout from 'layouts'
import NotFoundPage from 'pages/404'
import { userLogOut } from './redux/user/actions'

import ErrorBoundry from './services/errorBoundry'

const loadable = loader =>
  Loadable({
    loader,
    delay: false,
    loading: () => <Loader />,
  })

const routes = [
  // System Pages
  {
    path: '/user/old-login',
    component: loadable(() => import('pages/user/login')),
    exact: true,
  },

  // new login and password reset for currency accounts

  {
    path: '/user/login',
    component: loadable(() => import('pages/user/login')),
    exact: true,
  },

  {
    path: '/user/password-reset',
    component: loadable(() => import('pages/user/newForgot')),
    // exact: true,
  },

  // end
  {
    path: '/user/register',
    component: loadable(() => import('pages/user/register')),
    exact: true,
  },
  {
    path: '/user/personal-details',
    component: loadable(() => import('pages/user/register/personalDetails')),
    exact: true,
  },
  {
    path: '/user/old-password-reset',
    component: loadable(() => import('pages/user/forgot')),
    // exact: true,
  },

  // manage auth0

  {
    path: '/user/setup-twoFactor-authentictaion',
    component: loadable(() => import('pages/user/auth0/setUp2FA')),
    exact: true,
  },
  {
    path: '/user/twoFactor-validation',
    component: loadable(() => import('pages/user/auth0/codeValidation')),
    exact: true,
  },
  // {
  //   path: '/user/auth-qrcode-validation',
  //   component: loadable(() => import('pages/user/auth0/qrCodeValidation')),
  //   // exact: true,
  // },

  // Pages
  {
    path: '/user-profile',
    component: loadable(() => import('pages/settings/profile')),
  },
  {
    path: '/reports',
    component: loadable(() => import('pages/manageDeposits/reports')),
  },
  {
    path: '/trades',
    component: loadable(() => import('pages/manageDeposits/trades')),
  },
  {
    path: '/new-trade',
    component: loadable(() => import('pages/manageDeposits/newTrade')),
  },
  {
    path: '/trade',
    component: loadable(() => import('pages/manageDeposits/trade')),
  },
  {
    path: '/account-balances',
    component: loadable(() => import('pages/currencyAccounts/clientBalances')),
  },
  {
    path: '/account-balance/account-summary/:id',
    component: loadable(() => import('pages/currencyAccounts/transactions')),
  },

  {
    path: '/payment-transaction-summary/:id',
    component: loadable(() => import('pages/currencyAccounts/transactions/transactionSummary')),
  },

  {
    path: '/new-payment',
    component: loadable(() => import('pages/digitalPayment')),
  },
  {
    path: '/new-payment-success',
    component: loadable(() => import('pages/digitalPayment/successPage')),
  },
]

const mapStateToProps = ({ user }) => ({
  token: user.token,
  passwordResetPath: user.passwordResetPath,
})

@connect(mapStateToProps)
class Router extends React.Component {
  componentDidMount() {
    const { token } = this.props
    if (token) {
      this.logoutOnTokenExpire(token)
    }
  }

  logoutOnTokenExpire = token => {
    const { dispatch } = this.props
    if (token) {
      const decodeToken = jwt.decode(token)
      const tokenExpireAt = decodeToken.exp
      const currentTime = (new Date().getTime() + 1) / 1000
      if (currentTime >= tokenExpireAt) {
        dispatch(userLogOut())
      } else {
        const setTime = (tokenExpireAt - currentTime) * 1000
        setTimeout(() => {
          dispatch(userLogOut())
        }, setTime)
      }
    }
  }

  render() {
    const { history } = this.props
    return (
      <ConnectedRouter history={history}>
        <IndexLayout>
          <Switch>
            <Route exact path="/" render={() => <Redirect to="/trades" />} />
            <ErrorBoundry>
              {routes.map(route => (
                <Route
                  path={route.path}
                  component={route.component}
                  key={route.path}
                  exact={route.exact}
                />
              ))}
            </ErrorBoundry>
            <Route component={NotFoundPage} />
          </Switch>
        </IndexLayout>
      </ConnectedRouter>
    )
  }
}

export default Router
